import { EntityState } from "@ngrx/entity";
import { StoryCtaTemplateEntity } from '@modules/shared/entities';

export interface StoryCtaTemplateState  extends EntityState<StoryCtaTemplateEntity> {
    loading:boolean,
    loaded:boolean
}